<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-tittle"><span>THE CAZALET FAMILY TREE</span></p>
<p class="image-center"><span><img alt="image" class="svg" src="images/1.jpg"/></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frantmatter03.vue?51000450